const cacheKeys = {
  SUB_ADMINS: 'sub-admins-list',
  REGISTERED_BABYSITTERS: 'registered-babysitters',
  REGISTERED_CONSUMERS: 'registered-consumers-list',
  HELP_POINT: 'help-point',
  GET_CONTANT: 'get-contant',
  GET_PROFILE: 'get-profile',
  NOTIFICATION: 'get-notifications-list',
  NOTIFICATION_COUNT: 'get-unread-notifications-count',
  ADMIN_RANDOM_CHECK_IN_BUTTON_STATUS: 'admin-random-check-in-button-status',
}

export default cacheKeys
